const getFromLocalStorage = () => {
  const token = localStorage.getItem('token') || '';
  const role = localStorage.getItem('role') || '';
  return { token, role };
};

export const initialState = { ...getFromLocalStorage(), accounts: [], count: 0, facturas: [], facturasCount: 0 };
